import { patientSignInUrl } from "../config";
import { LogoMark, LogoWord } from "./Logo";

/** Sticky top nav — logo lockup, same-page anchor links, Book-a-Demo CTA (per the DrStack design).
 * The "Sign in" link (patient portal, env-configured) is retained from the old marketing app. */
export function Nav() {
  return (
    <nav>
      <div className="wrap nav-inner">
        <a className="logo" href="#top" aria-label="DrStack home">
          <LogoMark size={36} gradientId="lg" />
          <LogoWord />
        </a>
        <div className="nav-links">
          <a href="#platform">Platform</a>
          <a href="#how">How It Works</a>
          <a href="#ai">AI</a>
          <a href="#trust">Security</a>
          <a href={patientSignInUrl()}>Sign in</a>
          <a href="#contact" className="btn btn-primary btn-sm">
            Book a Demo
          </a>
        </div>
      </div>
    </nav>
  );
}
